module.exports = __webpack_public_path__ + "img/34.0afa2f5f.jpg";